import React, { Component } from "react";
import { Link } from "react-router-dom";
import { siteConfig } from "../../settings";

const DEBUG = siteConfig.DEBUG;

export default class TopbarCommunity extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      userID: null,
      userImageUrl: null,
      userFirstname: "",
      userLastname: ""
    };
  }

  componentWillMount() {
    DEBUG && console.log("componentDidMount");
    this.state.userToken = localStorage.getItem("access_token");
    DEBUG && console.log("UserToken: " + this.state.userToken);

    this.state.userID = localStorage.getItem("userID");
    DEBUG && console.log("userID: " + this.state.userID);

    this.state.userFirstname = localStorage.getItem("userFirstname");
    DEBUG && console.log("userFirstname: " + this.state.userFirstname);

    this.state.userLastname = localStorage.getItem("userLastname");
    DEBUG && console.log("userLastname: " + this.state.userLastname);
  }

  render() {
    return (
      <div>
        <Link to="/dashboard/community">
          <h3 style={{ fontFamily: "Kanit" }}>
            {localStorage.getItem("userFirstname")}{" "}
            {localStorage.getItem("userLastname")}
          </h3>
        </Link>
      </div>
    );
  }
}
